class SubmitUpdatePaymentService {
  constructor(rest) {
    this.rest = rest;
  }

  request(clickSessionId) {
    return this.rest({
      method: 'POST',
      path: '/api/customer-self-management/rest/customerSelfManagement/V1/my-account/payment/card-changed2',
      entity: { clickSessionId }
    });
  }
}

export default SubmitUpdatePaymentService;



/** WEBPACK FOOTER **
 ** ./src/services/SubmitUpdatePaymentService.js
 **/